export default {
  name: 'Video Playlist Inline',
  selector: '.videoPlaylistInline:not([data-initialized])',
};
